import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ToolComponent} from './tool/tool.component';
import {authGuard} from '../core/services/guards/can-activate.guards';
import {AuthGuardData} from '../core/services/guards/guards';

const routes: Routes = [
  {
    path: '',
    component: ToolComponent
  },
  {
    path: 'easy-link',
    loadChildren: () => import('./easy-link-tool/easy-link-tool.module').then(m => m.EasyLinkToolModule)
  },
  {
    path: 'product-link',
    loadChildren: () => import('./product-link/product-link.module').then(m => m.ProductLinkModule)
  },
  {
    path: 'custom-link-builder',
    loadChildren: () => import('./custom-link-builder/custom-link-builder.module').then(m => m.CustomLinkBuilderModule)
  },
  {
    path: 'ad-management',
    loadChildren: () => import('./ad-management/ad-management.module').then(m => m.AdManagementModule),
    canActivate: [authGuard],
    data: <AuthGuardData>{
      checkPermission: ['configure_tools', 'merchant_access']
    }
  },
  {
    path: 'discounts',
    loadChildren: () => import('./discount-managment/discount-management.module').then(m => m.DiscountManagementModule),
    canActivate: [authGuard],
    data: <AuthGuardData>{
      checkPermission: ['configure_tools', 'merchant_access']
    }
  },
  { path: 'qr-code', loadChildren: () => import('./qr-code/qr-code-builder.module').then(m => m.QRCodeBuilderModule) },

  // Previous Url Redirects.
  {path: 'easy_link', redirectTo: 'easy-link'},
  {path: 'product_link', redirectTo: 'product-link'},
  {path: 'custom_link_builder', redirectTo: 'custom-link-builder'}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class ToolRoutingModule {}
